import { RequestAccountantAccess } from './model';
function wasRequested(requestAccountantAccess) {
    return requestAccountantAccess === RequestAccountantAccess.Mandatory || requestAccountantAccess === RequestAccountantAccess.Optional;
}
export const selectors = {
    wasRequested
};
